import React from 'react';
import { useGetStatisticsQuery } from "../../../services/BBFinanceAPI";
import Spinner from '../../utils/Spinner';

const StockStatistics = ({ticker}) => {
    const {data: stats, isFetching} = useGetStatisticsQuery(ticker); 
    const stockStatistics = stats?.result[0]?.table;
    return (
        <div>
            {
                isFetching 
                ? <Spinner />
                : (
                   <div className="row mt-5 px-2">
                       {
                            stockStatistics?.map((stat,i) => (
                                <div className="col-md-3 my-4 d-flex flex-column justify-content-between" key={i}>
                                    <span className="mb-2"><strong>{stat.name}</strong></span>
                                    <span>{stat.value}</span>
                                </div>
                            ))
                       }
                   </div>
                  )
            }
        </div>
    )
}

export default StockStatistics
